// extracted by mini-css-extract-plugin
export default {"main":"StaticPage_main__1Lu-W","title":"StaticPage_title__E4FYX"};